import React from 'react';
import effectiveIcon from '../../../../images/icons/effectively-icon.png';
import safetyIcon from '../../../../images/icons/safety-icon.png';
import timeIcon from '../../../../images/icons/time-icon.png';
import flexibilityIcon from '../../../../images/icons/flexibility-icon.png';

// Note: The symbols array should be provided as a prop or imported from a constants file
const defaultSymbols = ['*', '†', '‡', '§', '*', '†', '2'];

const CardLeftBordered =({ title, children, symbols, showFooterText = true })  => {
  // const symbols = [...defaultSymbols]; // This should be the actual symbols array passed as a prop

  if (!Array.isArray(symbols)) {
    symbols = defaultSymbols;
  }

  const renderSymbol = (symbol) => {
    return symbol === '*' ? symbol : <sup>{symbol}</sup>;
  };

  return (
    <div className='card-left-bordered'>
      <div className="content-wrap">
        <div className="title">
          <span className='font-22 bold txt-blue' role="heading" aria-level="2">Nalmefene HCl Essentials</span>
        </div>

        <div className="content">
          <h3>HELP TAKE CONTROL OF OPIOID OVERDOSE UNKNOWNS WITH NALMEFENE HCl</h3>
          <ul className="cards-list">
            <li className={`card-icon w-44`}>
              <div className="card-icon__media">
                <img src={effectiveIcon} alt='' />
              </div>
              <div className='card-icon__content'>
                <p>Effectively reversed respiratory depression within <nobr><strong>2 to 5 minutes</strong></nobr> in most patients{renderSymbol(symbols[0])}</p>
              </div>
            </li>
            <li className={`card-icon  w-44`}>
              <div className="card-icon__media">
                <img src={timeIcon} alt='' />
              </div>
              <div className='card-icon__content'>
                <p><strong>10.8-hour</strong> mean terminal elimination half-life{renderSymbol(symbols[1])}</p>
              </div>
            </li>
            <li className={`card-icon w-44`}>
              <div className="card-icon__media">
                <img src={safetyIcon} alt='' />
              </div>
              <div className='card-icon__content'>
                <p>Safety and tolerability similar to naloxone{renderSymbol(symbols[2])}</p>
              </div>
            </li>
            <li className={`card-icon w-44`}>
              <div className="card-icon__media">
                <img src={flexibilityIcon} alt='' />
              </div>
              <div className='card-icon__content'>
                <p>Flexibility to be given as <strong>IV, IM, or SC</strong> injection{renderSymbol(symbols[3])}</p>
              </div>
            </li>
          </ul>
          <div className="footnote">
          {showFooterText && <p>IM=intramuscular; IV=intravenous; SC=subcutaneous.</p>} 
            <div className="d-flex">
              <span>{renderSymbol(symbols[4])}</span>
              <p>Studied in 284 patients presumed to have taken an opioid overdose. Effectively reversed respiratory depression at doses of 0.5 mg to 1 mg. Dose range in clinical trials was 0.5 mg to 2 mg.{renderSymbol(symbols[6])}</p>
            </div>
            <div className="d-flex">
              <span>{renderSymbol(symbols[5])}</span>
              <p>Nalmefene elimination half-life is based on pharmacokinetic data. The mean terminal elimination half-life is 10.8 hours and 9.4 hours in younger (19 to 32 years) and elderly (62 to 80 years) healthy male subjects, respectively, following a Nalmefene HCl 1 mg IV dose.{renderSymbol(symbols[7])}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardLeftBordered;
